import Company from 'pages/companies/Company'
import LoanView from 'pages/loan/LoanView'
import PeopleRoutes from 'pages/people/PeopleRoutes'
import { Breadcrumb } from 'peach/components'
import { Switch, Route, useParams } from 'peach/router'
import { CompanyManager } from 'peach/scopes/company'
import { useCompanyGet } from './types/generated/company/hooks'

const CompanyRoutes = () => {
  const { companyId } = useParams()

  const { data: company } = useCompanyGet({
    companyId,
  })

  return (
    <CompanyManager companyId={companyId}>
      <Breadcrumb title={company?.legalName} to={`/companies/${companyId}`} />

      <Switch>
        <Route path='/companies/:companyId/borrowers/:personId/loans/:loanId'>
          <LoanView />
        </Route>

        <Route path='/companies/:companyId/borrowers/:personId'>
          <Breadcrumb
            title='Borrowers'
            to={`/companies/${companyId}/borrowers`}
          />
          <PeopleRoutes />
        </Route>

        <Route path='/companies/:companyId'>
          <Company />
        </Route>
      </Switch>
    </CompanyManager>
  )
}

export default CompanyRoutes
